import React, { Component } from "react";
import styled from "styled-components";
import { connect } from "react-redux";
import { withRouter } from "react-router-dom";
import Tabs from "react-bootstrap/Tabs";
import Tab from "react-bootstrap/Tab";
import { Row } from "styled-bootstrap-grid";
//import { CaretDown } from "styled-icons/boxicons-regular/CaretDown";
//import { CaretUp } from "styled-icons/boxicons-regular/CaretUp";
//import {Dropdown, DropdownItem, DropdownMenu } from "styled-dropdown-component";
import { ChevronLeft } from "styled-icons/boxicons-regular";
//import ClickOutside from "react-simple-click-outside";
import EmployeeList from "../EmployeeList";
import WeekView from "../WeekView";
//import IconFilter from "./iconfilter.png";
import { showModal, hideModal } from "../../../../Actions";
import Shift from "../Shift";
import BranchClosure from "../BranchClosure";
import ScheduledHours from "../ScheduledHours";
import { withTranslation, Trans } from "react-i18next";
import { BreadcrumbsItem } from "react-breadcrumbs-dynamic";
import {
  getManagerTimesheetData,
  holidaySaveReset,
  resetStandyMessage,
  resetShiftMessage,
  resetAprroveMessage,
  resetEmployeeMessage,
  resetaddWeekPlanner,
  managerApproveTimesheetWeek
} from "../../../../Actions";
import { format, endOfWeek, startOfWeek, addDays, subDays } from "date-fns";
import WeekPlanner from "../WeekPlanner";
import ShiftView from "../ScheduledHours/ShiftView";
import { getShiftWiseEmployees } from "../../../../Actions/shiftWiseEmployees";
import { dateFormat } from "../../../../Api/Utils/ReuseableFunctions"
class HomeComponent extends Component {
  constructor(props) {
    super(props);
    this.state = {
      hiddenData: true,
      hidden: true,
      dropdownfilter: ["Attended", "Absent", "On Call", "Breaks", "Worked"],
      dropdown: "Attended",
      showDropDown: true,
      selectedDate: "",
      tab: "1",
      startDate: props.dateDataDown ? dateFormat(props.dateDataDown.startDate) : startOfWeek(new Date(), { weekStartsOn: 1 }),
      endDate: props.dateDataDown ? dateFormat(props.dateDataDown.endDate) : endOfWeek(new Date(), { weekStartsOn: 1 }),
      showModal: false
    };
    this.openAlertModal = this.openAlertModal.bind(this);
    this.closeModal = this.closeModal.bind(this);

  }

  actionWeek = action => {
    this.setState(
      state => ({
        startDate:
          action === "previous"
            ? subDays(state.startDate, 7)
            : addDays(state.startDate, 7),
        endDate:
          action === "previous"
            ? subDays(state.endDate, 7)
            : addDays(state.endDate, 7)
      }),
      () => {
        this.getData();
      }
    );
  };

  switchScheduleHours = () => {
    this.setState(state => {
      return { showModal: !state.showModal }
    })
  }

  getData = () => {
    let payload = {
      ssoId: this.props.ssoId,
      workshopLocation: this.props.userDefault.branchId,
      role: this.props.userDefault.emplRole,
      endDate: format(this.state.endDate, "dd/MM/yyyy"),
      startDate: format(this.state.startDate, "dd/MM/yyyy")
    }
    this.props.managerWeekData(
      payload
    );
    if (this.state.showModal) {
      this.props.getShiftWiseEmployees(
        payload
      );
    }
    this.props.dateDataUp({ startDate: format(this.state.startDate, "dd/MM/yyyy"), endDate: format(this.state.endDate, "dd/MM/yyyy") });
  };
  componentDidMount() {
    if (this.props.dateDataDown === void 0) {
      this.props.managerWeekData({
        ssoId: this.props.ssoId,
        workshopLocation: this.props.branchId,
        role: this.props.emplRole,
        endDate: "",
        startDate: ""
      });

    } else {
      this.getData()
    }
    this.props.dateDataUp({ startDate: format(this.state.startDate, "dd/MM/yyyy"), endDate: format(this.state.endDate, "dd/MM/yyyy") });
  }

  componentDidUpdate(prevProps) {
    let payload = {
      ssoId: this.props.ssoId,
      workshopLocation: this.props.branchId,
      role: this.props.userDefault.emplRole
        ? this.props.userDefault.emplRole
        : this.userData.emplRole,

      endDate: this.state.endDate
        ? format(this.state.endDate, "dd/MM/yyyy")
        : "",
      startDate: this.state.startDate
        ? format(this.state.startDate, "dd/MM/yyyy")
        : ""
    };
    if (this.props.holidayMessage.errorCd === "SUCCESS") {
      this.props.managerWeekData(payload);
      this.props.resetHolidayMessage();
    }
    if (this.props.employeeMessage.errorCd === "SUCCESS") {
      this.props.managerWeekData(payload);
      this.props.resetEmployeeMessage();
    }
    if (this.props.shiftUpdateMessage.errorCd === "SUCCESS") {
      this.props.managerWeekData(payload);
      this.props.resetShiftMessage();
      this.props.resetaddWeekPlanner();
    }
    if (this.props.standByMessage.errorCd === "SUCCESS") {
      this.props.managerWeekData(payload);
      this.props.resetStandyMessage();
    }

    if (this.props.approveWeekDataMesage.errorCd === "SUCCESS") {
      this.props.managerWeekData(payload);
      this.props.resetAprroveMessage();
    }

  }
  openAlertModal(date, ssoId) {
    this.props.showModal(
      {
        open: true,
        title: "Alert Modal",
        message: "MESSAGE",
        date: date,
        techssoId: ssoId,
        closeModal: this.closeModal
      },
      "Manager/StandByPopUp/index"
    );
  }

  closeModal(event) {
    this.props.hideModal();
  }
  _close = target => {
    this.setState({
      [target]: true
    });
  };

  filter = index => {
    this.setState({
      dropdown: this.state.dropdownfilter[index],
      hidden: true,
      hiddenData: true
    });
  };

  handleDate = weekData => {
    this.setState(
      {
        startDate: weekData.startDate,
        endDate: weekData.endDate
      },
      () => {
        this.getData();
      }
    );
  };
  handleselect = data => {
    this.setState({ showDropDown: data !== 1 ? false : true, tab: data });
    //Dispatch Service
    // if(this.state.showDropDown !== 3){
    //   console.log("Enter");
    //   this.props.dispatch(getShiftWiseEmployees({ ssoId: this.props.ssoId,
    //     branchNr: this.props.userDefault.branchId,
    //     empRole: this.props.userDefault.empRole,
    //     startDate: this.props.weekData.fromDate,
    //     endDate: this.props.weekData.toDate
    //   }));
    // }
  };
  updateWeekData = () => {
    var payload = {
      ssoId: this.props.ssoId,
      branchNr: this.props.branchId,
      startDay: format(this.state.startDate, "dd/MM/yyyy"),
      endDay: format(this.state.endDate, "dd/MM/yyyy")
    };
    this.props.showModal(
      {
        open: true,
        payload: payload,
        serviceName: managerApproveTimesheetWeek,
        closeModal: this.closeModal
      },
      "Manager/ConfirmBox/index"
    );
    //this.props.approveWeekData(payload);
  };

  render() {
    const { t, ssoId } = this.props;
    const { showModal } = this.state;
    return this.props.weekData !== void 0 ? (
      <>
        <BreadcrumbsItemDiv
          glyph
          to={"/timetracking/" + ssoId + "/manager/home/"}
        >
          {this.state.tab === "1" && <Trans>approveTimesheet</Trans>}
          {this.state.tab === "2" && <Trans>employee</Trans>}
          {this.state.tab === "3" && <Trans>scheduledHours</Trans>}
          {this.state.tab === "4" && <Trans>shift</Trans>}
          {this.state.tab === "5" && <Trans>weeklyPlanner</Trans>}
          {this.state.tab === "6" && <Trans>branchClosure</Trans>}
        </BreadcrumbsItemDiv>
        <TabDiv>
          <RowDiv>
            {/* {this.state.showDropDown && this.filterButton()} */}
            <TabsDiv
              activeKey={this.state.tab}
              onSelect={data => this.handleselect(data)}
            >
              <TAB eventKey={1} title={t("approveTimesheet")}>
                {this.state.tab === "1" && (
                  <WeekView
                    applyStandBy={this.openAlertModal}
                    approveData={() => { this.updateWeekData() }}
                    weekAction={this.actionWeek}
                    startDate={this.state.startDate}
                    endDate={this.state.endDate}
                  />
                )}
              </TAB>
              <TAB eventKey={2} title={t("employee")}>
                {/* <TabParentTec>
                  <CaretuP size="20" />
                </TabParentTec> */}
                {this.state.tab === "2" && (
                  <EmployeeList BackTab={data => this.handleselect("1")} />
                )}
              </TAB>
              <TAB eventKey={3} title={t("scheduledHours")}>
                <ToggleDiv>
                  <ToggleInnerDivShiftView disabled={showModal} onClick={this.switchScheduleHours}>
                    <div className="check" >
                      <Trans>shiftView</Trans>
                    </div>
                  </ToggleInnerDivShiftView>
                  <ToggleInnerDiv disabled={!showModal} onClick={this.switchScheduleHours}>
                    <div className="active">
                      <Trans>technicianView</Trans>
                    </div>
                  </ToggleInnerDiv>
                </ToggleDiv>

                {this.state.tab === "3" && (
                  showModal ? <ShiftView
                    startDate={this.state.startDate}
                    endDate={this.state.endDate}
                    BackTab={data => this.handleselect("2")}
                    weekAction={this.actionWeek}
                    updateData={this.getData}
                  /> :
                    <ScheduledHours
                      startDate={this.state.startDate}
                      endDate={this.state.endDate}
                      BackTab={data => this.handleselect("2")}
                      weekAction={this.actionWeek}
                      updateData={this.getData}
                    />
                )}
              </TAB>
              <TAB eventKey={4} title={t("shift")}>
                {this.state.tab === "4" && (
                  <Shift BackTab={data => this.handleselect("3")} />
                )}
              </TAB>
              <TAB eventKey={5} title={t("weeklyPlanner")}>
                {this.state.tab === "5" && (
                  <WeekPlanner BackTab={data => this.handleselect("4")}
                    editanddelete={true}
                    handleEditClick={(data) => { }}
                    handleDeleteClick={(data) => { }}
                  />
                )}
              </TAB>
              <TAB eventKey={6} title={t("branchClosure")}>
                {this.state.tab === "6" && (
                  <BranchClosure BackTab={data => this.handleselect("5")} />
                )}
              </TAB>
              <Caretleft size="24" />
            </TabsDiv>
          </RowDiv>
        </TabDiv>
      </>
    ) : (
        <div />
      );
  }
}

const BreadcrumbsItemDiv = styled(BreadcrumbsItem)`
  .active{
    pointer-events: none !important;
  }
`;
const TAB = styled(Tab)`
  color: #4a4a4a;
  min-width: 1010px;
`;
const TabDiv = styled.div`
  font-family: Trebuchet MS;
  font-size: 12px;
  box-shadow: 0 4px 2px -2px #80808040;
  height: 32px;
  position: relative;
  bottom: 1%;
}`;
const RowDiv = styled(Row)`
  margin:0px;
  max-heigth: 123px;
  heigth :123px
  padding-left: 6px;
  border-left: 2px solid #f1f4f9;
  border-right: 2px solid #f1f4f9;
  padding-left:20px
  text-align: left;
  .nav {
    border-bottom: none;
    bottom: 6px;
    position: relative;
  }
  .tab-content{width:100%
  text-align:center
  display: flex;
  flex: 1 1 auto;
  //overflow: scroll;
  height: 100%;
  flex-flow: column wrap;
  }
  .nav-tabs .nav-link {
    border: none;
    border-top-left-radius: 0px;
    border-top-right-radius: opx;
    color: #7e7e7e;
    height: 33px;
  }
  .nav-tabs .nav-item.show .nav-link,
  .nav-tabs .nav-link.active {
    height: 40px;
    border-bottom: 2px solid #00a6eb;
    color: #495057;
    background: none;
  }
  .nav-tabs .nav-item.show .nav-link,
  .nav-tabs .nav-link.active::after{
    content:'';
    top:0;
    left:42%;
    display:flex;
    width:0;
    height:0;
    position:relative;
    border-bottom:8px solid #00a6eb;
    border-left:8px solid transparent;
    border-right:8px solid transparent;
    clear:both;
  }`;

const ToggleDiv = styled.div`
  display: flex;
  position: absolute;
  right: 95px;
  top: 45px;
  cursor: pointer;
`;
const ToggleInnerDiv = styled.div`
  width: 9vw;
  height: 32px;
  border: 1px solid #8080806e;
  border-radius: 2px;
  border-top-right-radius: 5px;
  border-bottom-right-radius: 5px;
  pointer-events: ${props => props.disabled ? "none" : "cursor"};
  && div {
    background:${props => props.disabled ? "#00a6eb" : "none"};
    color: ${props => props.disabled ? "#ffffff" : "#000000"};
    width: 100%;
    height: 100%;
    padding-top: 4px;
    font-size: 15px;
  }`;
const ToggleInnerDivShiftView = styled.div`
  width: 9vw;
  height: 32px;
  border: 1px solid #8080806e;
  border-radius: 2px;
  border-top-left-radius: 5px;
  border-bottom-left-radius: 5px;
  pointer-events: ${props => props.disabled ? "none" : "cursor"};
  && div {
    background:${props => props.disabled ? "#00a6eb" : "none"};
    color: ${props => props.disabled ? "#ffffff" : "#000000"};
    width: 100%;
    height: 100%;
    padding-top: 4px;
    font-size: 15px;
  }`;
const TabsDiv = styled(Tabs)`
  width: 100%;
  font-size: 16px;
`;
const Caretleft = styled(ChevronLeft)`
  position: relative;
  right: 8px;
  bottom: 4px;
  background: #00a6eb;
  border-radius: 20px;
`;
const mapStateToProps = ({
  auth,
  userMessage,
  managerTimesheetData,
  employeeOnboard,
  holidayManager,
  shiftUpdate,
  standBy,
  approveWeekData
}) => {
  return {
    isAuthenticated: auth.isAuthenticated,
    ssoId: auth.ssoId,
    message: userMessage,
    userDefault: auth.user.defaultProfile,
    weekData: managerTimesheetData.payload.weekDataDetails,
    branchId: auth.user ? auth.user.defaultProfile.branchId : null,
    emplRole: auth.user.defaultProfile.emplRole,
    userData: auth.user.defaultProfile,
    employeeMessage: employeeOnboard.message,
    holidayMessage: holidayManager.message,
    shiftUpdateMessage: shiftUpdate.message,
    standByMessage: standBy.message,
    approveWeekDataMesage: approveWeekData.message
  };
};

const mapDispatchToProps = dispatch => ({
  hideModal: () => dispatch(hideModal()),
  showModal: (modalProps, template) => {
    dispatch(showModal({ modalProps, template }));
  },

  managerWeekData: payload => {
    dispatch(getManagerTimesheetData(payload));
  },

  resetHolidayMessage: payload => {
    dispatch(holidaySaveReset());
  },
  resetEmployeeMessage: payload => {
    dispatch(resetEmployeeMessage());
  },
  resetShiftMessage: () => {
    dispatch(resetShiftMessage());
  },
  resetStandyMessage: () => {
    dispatch(resetStandyMessage());
  },
  resetAprroveMessage: () => {
    dispatch(resetAprroveMessage());
  },
  resetaddWeekPlanner: () => {
    dispatch(resetaddWeekPlanner())
  },
  getShiftWiseEmployees: (payload) => { dispatch(getShiftWiseEmployees(payload)) }
});

export default withRouter(
  connect(
    mapStateToProps,
    mapDispatchToProps
  )(withTranslation()(HomeComponent))
);
